import { type ReactElement } from 'react'
import { PermissionContent, PickUserSearch, TDrawer } from '@components'
import { SizePrimitives, useUser } from '@front/model'
import { Group, Skeleton, Stack, Text } from '@mantine/core'
import { getName, isDefined } from '@terros/common'
import { parseAsUserId } from '@util'
import { useQueryState } from 'nuqs'

export const UsersPermissions = (): ReactElement => {
  const [userId, setUserId] = useQueryState('userId', parseAsUserId)

  const { data: user } = useUser(userId ?? undefined)

  return (
    <Stack>
      <PickUserSearch
        options={{ downline: true }}
        onSelect={(user) => {
          setUserId(user.userId)
        }}
      />
      <TDrawer
        opened={isDefined(userId)}
        size='xl'
        title={
          <Group gap={SizePrimitives['1']}>
            Permissions for
            {user ? (
              <Text inherit span c='brand'>
                {getName(user)}
              </Text>
            ) : (
              <Skeleton h={SizePrimitives['6']} w={SizePrimitives['40']} />
            )}
          </Group>
        }
        onClose={() => setUserId(null)}
      >
        {userId && <PermissionContent entityId={userId} />}
      </TDrawer>
    </Stack>
  )
}
